<div class="ticket-card-modal">
  <div class="ticket-card-modal-data">
    <div>Létrehozta:</div>
    <div>{{ticket.createdBy.lastName}} {{ticket.createdBy.firstName}}</div>
  </div>
  <div class="ticket-card-modal-data">
    <span class="ticket-card-modal-data-title" [ngStyle]="{ marginTop: '10px' }">Cím:</span>
    <mat-form-field>
      <mat-label>Cím</mat-label>
      <input
        type="text"
        placeholder="Pick one"
        aria-label="Number"
        matInput
        [(ngModel)]="ticket.address"
        [matAutocomplete]="auto"
        (input)="buffer()"
      >
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of searchList" [value]="option">
          {{option}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="ticket-card-modal-data" [ngStyle]="{ marginTop: '-4px' }">
    <span class="ticket-card-modal-data-title" [ngStyle]="{ marginTop: '5px' }">Kategória:</span>
    <mat-select [value]="getValue()" (selectionChange)="changeCat($event.value)">
      <mat-option
        *ngFor="let cat of categories;"
        [value]="cat"
        class="statistics-option"
      >{{cat.name}}</mat-option>
    </mat-select>
  </div>
  <div class="ticket-card-modal-data">
    <span class="ticket-card-modal-data-title">Státusz:</span>
    <mat-button-toggle-group
      (change)="changeStatus($event.value)"
    >
      <mat-button-toggle
        *ngFor="let status of statuses;"
        [value]="status.name"
        [checked]="status.name === ticket.ticketStatus.name"
      >{{status.niceName}}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div *ngFor="let attribute of ticket.ticketAttributeValues; let i;" [ngStyle]="{ display: attribute.ticketAttribute.auto ? 'none' : 'block' }" class="ticket-card-modal-data">
    <span [ngStyle]="{ display: attribute.ticketAttribute.isDate ? 'block' : 'inline-flex' }" *ngIf="!attribute.ticketAttribute.auto" class="ticket-card-modal-data-title">{{attribute.name}}:</span>
    <mat-button-toggle-group
      *ngIf="!attribute.ticketAttribute.isDate && !attribute.ticketAttribute.multi && !attribute.ticketAttribute.auto"
      (change)="changeAttribute($event.value, attribute)"
    >
      <mat-button-toggle
        *ngFor="let value of attribute.ticketAttribute.possibleValues;"
        [value]="value"
        [checked]="attribute.value[0] === value"
      >{{value}}</mat-button-toggle>
    </mat-button-toggle-group>
    <div
      class="mat-button-toggle-group mat-button-toggle-group-appearance-standard"
      *ngIf="attribute.ticketAttribute.multi"
    >
      <span
        class="mat-button-toggle mat-button-toggle-appearance-standard"
        *ngFor="let value of attribute.ticketAttribute.possibleValues;"
        [class.mat-button-toggle-checked]="isChecked(attribute, value)"
        (click)="changeMultiAttribute(value, attribute)"
      >
      <button class="mat-button-toggle-button mat-focus-indicator">
        <span
        class="mat-button-toggle-label-content"
        >{{value}}</span>
      </button>
    </span>
  </div>
    <mat-form-field [ngStyle]="{ background: '#DB9406' }" *ngIf="attribute.ticketAttribute.isDate && !attribute.ticketAttribute.auto" class="yellow button-on-top">
      <mat-label class="answer-container">{{attribute.ticketAttribute.name}}</mat-label>
      <input matInput [matDatepicker]="picker1" (dateChange)="fillDate($event.value, attribute)" [value]="getValueDate(attribute.value)">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="ticket-card-modal-data">
    <span class="ticket-card-modal-data-title" [ngStyle]="{ marginTop: '10px' }">Megjegyzés:</span>
    <mat-form-field>
      <mat-label></mat-label>
      <input
        type="text"
        placeholder="Megjegyzés"
        aria-label="Number"
        matInput
        [(ngModel)]="ticket.description"
      >
    </mat-form-field>
  </div>
  <div class="ticket-card-modal-button">
    <span></span>
    <app-button
      (click)="update()"
      [title]="'Mentés'"
      [fontSize]="20"
      [customColor]="'yellow'"
    ></app-button>
  </div>
</div>